/* eslint-disable no-unused-vars */
import { AuthApi } from "@/services/api/AuthApi";

export class AuthService {
  authApi: AuthApi;

  constructor() {
    this.authApi = new AuthApi();
  }

  // Авторизация
  authorize(data: any){
    
    return new Promise((resolve, reject) => {

      // Пробуем авторизоваться
      this.authApi.login(data)
        .then(
          (response:any) => {

            // Получаем accessToken и записываем его в локальное хранилище
            localStorage.setItem('accessToken', response.getAccessToken());

            // Получаем refreshToken и записываем его в локальное хранилище
            localStorage.setItem('refreshToken', response.getRefreshToken());

            // Создаем пользователя
            const user:any = {
              id: response.getUserId(),
              role: response.getUserRole()
            }

            // Записываем пользователя в локальное хранилище
            localStorage.setItem('user', JSON.stringify(user));

            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  // Обновление токена
  refreshToken(){

    // Получаем refreshToken из локального хранилища
    const refreshToken = localStorage.getItem('refreshToken');
    console.log('Refresh token from localstorage ', refreshToken)
    return new Promise((resolve, reject) => {

      // Пробуем обновить токен
      this.authApi.refresh({
        refreshToken: refreshToken
      })
        .then(
          (response:any) => {

            // Получаем accessToken и записываем его в локальное хранилище
            localStorage.setItem('accessToken', response.getAccessToken());

            // Получаем refreshToken и записываем его в локальное хранилище
            localStorage.setItem('refreshToken', response.getRefreshToken());

            // Создаем пользователя
            const user:any = {
              id: response.getUserId(),
              role: response.getUserRole()
            }

            // Записываем пользователя в локальное хранилище
            localStorage.setItem('user', JSON.stringify(user));

            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
}